import React from 'react';
import { Headphones, Globe, Clock } from 'lucide-react';

interface OnboardingScreenProps {
  onDismiss: () => void;
}

const SPANISH_ORANGE = '#f78320';

const features = [
  { Icon: Headphones, text: 'Nearly 8 hours of guided audio instruction' },
  { Icon: Globe,      text: '15 native speakers from around the world' },
  { Icon: Clock,      text: 'Just 10 minutes a day — fits any schedule' },
];

const OnboardingScreen: React.FC<OnboardingScreenProps> = ({ onDismiss }) => {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-8 py-12 text-white"
      style={{ background: 'linear-gradient(160deg, #140040 0%, #280070 55%, #140040 100%)' }}
    >
      {/* S Logo */}
      <img
        src="/images/spanish-s.png"
        alt="SPANISH"
        className="w-28 h-28 mb-8 drop-shadow-xl"
      />

      {/* Title */}
      <div className="text-center mb-10">
        <h1
          className="text-5xl font-black tracking-tight leading-none"
          style={{ color: SPANISH_ORANGE }}
        >
          SPANISH
        </h1>
        <p
          className="text-xl text-white/90 mt-2"
          style={{ fontFamily: "'Lora', 'Georgia', serif", fontStyle: 'italic' }}
        >
          in 10 minutes a day<sup style={{ fontStyle: 'normal', fontSize: '0.55em', verticalAlign: 'super' }}>®</sup>
        </p>
        <p className="text-xs uppercase tracking-[0.25em] text-white/50 mt-2 font-medium">
          Audio Series
        </p>
      </div>

      {/* Tagline */}
      <p className="text-center text-white/75 text-base leading-relaxed mb-10 max-w-xs">
        Build real conversational confidence — with authentic voices from across the Spanish-speaking world.
      </p>

      {/* Feature bullets */}
      <div className="space-y-5 mb-12 w-full max-w-xs">
        {features.map(({ Icon, text }) => (
          <div key={text} className="flex items-center space-x-4">
            <div
              className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
              style={{
                backgroundColor: 'rgba(247, 131, 32, 0.15)',
                border: '1px solid rgba(247, 131, 32, 0.4)',
              }}
            >
              <Icon size={18} color={SPANISH_ORANGE} />
            </div>
            <p className="text-white/80 text-sm leading-snug">{text}</p>
          </div>
        ))}
      </div>

      {/* CTA Button */}
      <button
        onClick={onDismiss}
        className="w-full max-w-xs py-4 rounded-2xl font-bold text-white text-2xl shadow-2xl transition-all active:scale-95 hover:brightness-110"
        style={{ backgroundColor: SPANISH_ORANGE }}
      >
        Start Learning
      </button>

      <p className="mt-8 text-xs text-white/30 text-center">
        A Bilingual Books, Inc. product
      </p>
    </div>
  );
};

export default OnboardingScreen;
